import { countTypeEnum, spsaOperationEnum, spsaPrevOperationEnum } from '@gtpl/shared-models/common-models'

export class ItemssubLotDto{
    sublotNumber:string
    lotNumber:string
    quantity:number
    opBoxes:number
    count?:number
    prodInvId ?: number
    clubbedQuantity ?: number
    year?:number
    prevOperation ?: spsaPrevOperationEnum
    operation ?: spsaOperationEnum
    countType?:countTypeEnum
    constructor(
        sublotNumber:string,
        lotNumber:string,
        quantity:number,
        opBoxes:number,
        count?:number,
        prodInvId ?: number,
        clubbedQuantity ?: number,
        year?:number,
        prevOperation ?: spsaPrevOperationEnum,
        operation ?: spsaOperationEnum,
        countType?:countTypeEnum
    ){
        this.sublotNumber=sublotNumber;
        this.lotNumber=lotNumber;
        this.quantity=quantity;
        this.opBoxes=opBoxes;
        this.count = count;
        this.prodInvId = prodInvId
        this.clubbedQuantity = clubbedQuantity
        this.year = year
        this.prevOperation = prevOperation
        this.operation = operation
        this.countType = countType
    }
     }